<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator" style="margin-bottom:8px">
          <!--<a-button type="default" icon="plus" v-action:addGroup @click="addGroup">添加分组</a-button>-->
          <a-button type="default" icon="plus" v-action:addUser @click="addUser">添加人员</a-button>
          <!-- <a-popconfirm
              title="确定要批量移除吗?"
              :visible="visible"
              @visibleChange="handleVisibleChange"
              @confirm="batchDel"> -->
          <a-button icon="delete" v-action:deleteUser @click="handleDel">批量移除</a-button>
          <!-- </a-popconfirm> -->
        </div>
        <!--表格-->
        <a-table
          :columns="table.columns"
          :rowKey="record => record.id+''+record.type"
          :dataSource="table.data"
          :pagination="pagination"
          :loading="table.listLoading"
          @change="handleTableChange"
          :rowSelection="rowSelection"
        >
          <template slot="type" slot-scope="text, record">
            <span v-if="record.type === 1">人员</span>
            <span v-if="record.type === 2">分组</span>
          </template>
          <template slot="actions" slot-scope="text, record">
            <a-popconfirm
              v-if="table.data.length"
              :title="`确定要移除【${record.name}】吗?`"
              @confirm="() => onDelete(record)"
            >
              <a v-action:deleteUser href="javascript:;">移除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <add-user ref="addUser" @refreshTable="initTableData"></add-user>
    <add-group ref="addGroup" @refreshTable="initTableData"></add-group>
  </div>
</template>

<script>
import { getUserList, deleteRoleGroupUser } from '@/api/roleList'
import addUser from './modules/addUser'
import addGroup from './modules/addGroup'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
export default {
  name: 'RoleList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
  },
  computed: {
    roleId () {
      return this.$store.state.role.roleId
    },
    roleName () {
      return this.$store.state.role.roleName
    }
  },
  watch: {
    roleId (id) {
      this.initTableData()
    }
  },
  components: {
    addUser,
    addGroup,
    searchForm,
    baseCard
  },
  // props: {
  //   roleId: Number
  // },
  data () {
    return {
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        selectedRowKeys: [],
        onChange: (selectedRowKeys, selectedRows) => {
          this.rowSelection.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: [],
        columns: [
          {
            title: '名称',
            dataIndex: 'name'
          },
          {
            title: '编号',
            dataIndex: 'number',
            width: '17%'
          },
          {
            title: '所属部门',
            dataIndex: 'departmentname',
            width: '18%'
          },
          {
            title: '所属公司',
            dataIndex: 'subcompanyname',
            width: '23%'
          },
          /* {
            title: '类型',
            dataIndex: 'type',
            scopedSlots: {
              customRender: 'type'
              },
          }, */
          {
            title: '操作',
            width: '15%',
            scopedSlots: {
              customRender: 'actions'
            }
          }
        ],
        searchCondition: {},
        listLoading: false
      },
      // 批量移除确认框
      visible: false
    }
  },
  methods: {
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination }
      this.searchModel.roleId = this.roleId
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    initTableData () {
      this.searchModel.roleId = this.roleId
      this.table.listLoading = true
      this.selectedRows = []
      getUserList(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.listLoading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
          // 清空已选项绑定key值
          this.rowSelection.selectedRowKeys = []
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination
      }
      this.initTableData()
    },
    // 移除操作
    onDelete (model) {
      const user = []
      user.push({
        id: model.id,
        type: model.type
      })
      const params = {
        roleId: this.roleId,
        user: user
      }
      deleteRoleGroupUser(params).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 新增分组
    addGroup () {
      this.$refs.addGroup.open(true)
    },
    // 添加人员
    addUser () {
      this.$refs.addUser.open(true)
    },
    // 批量移除
    handleDel () {
      const searchModel = this.selectedRows
      if (!searchModel || searchModel.length === 0) {
        this.$message.error('请至少选择一行数据进行移除！')
        return
      }
      this.$confirm({
        title: `【${this.roleName}】人员移除`,
        content: (h) => {
          let users = ''
          for (const i in this.selectedRows) {
            users += `【${this.selectedRows[i].name}】`
          }
          return `确定要移除${users}吗？`
        },
        onOk: (e) => this.batchDel(e),
        onCancel () {}
      })
    },
    batchDel (e) {
      const user = this.selectedRows.map(item => {
        return {
          id: item.id,
          type: item.type
        }
      })
      const params = {
        roleId: this.roleId,
        user: user
      }
      deleteRoleGroupUser(params).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
          e()
        } else {
          this.$message.error(res.info.message)
          e()
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
